import {Outlet, useLocation} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";
import ErrorPage from "../pages/ErrorPage.tsx";

type ProtectedLayoutProps = {
    allowedRoles: string[];
};

const ProtectedLayout = ({allowedRoles}: ProtectedLayoutProps) => {
    const {loggedInUser} = useAuth();
    const location = useLocation();
    const currentPath = location.pathname + location.search;

    if (!loggedInUser) {
        window.location.href = `/auth/ibmid?redirectTo=${encodeURIComponent(currentPath)}`; // Redirect to the backend authentication route
        return null;
    }

    if (!loggedInUser.role || !allowedRoles.includes(loggedInUser.role)) {
        return <ErrorPage/>;
    }

    return (
        <>
            <Outlet/>
        </>
    );
};

export default ProtectedLayout;
